<app-edit-project [isFromAuditProjectInfo]=true></app-edit-project>